import React, { Component } from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Profile from '../assets/images/website/profile.png';

class SimpleSlider extends Component {
    constructor(props) {
        super(props);

        this.owlOptions = {
            items: 3, // Default to 3 items
            autoplay: true,
            autoplayTimeout: 3000,
            loop: true,
            margin: 20,
            responsive: {
                0: {
                    items: 1,
                },
                600: {
                    items: 2, 
                },
                800: {
                    items: 3, 
                },
                1000: {
                    items: 3, 
                },
            },
        };
    }
    

    render() {
        const { hospitals } = this.props; // Expecting an array of hospitals

        return (
            <div className='container-90'>
                {/* <div className='ps-lg-5 ps-2 py-5'> */}
                <div className=''>
                    <OwlCarousel className="owl-theme" {...this.owlOptions}>
                        {hospitals.map((hospital, index) => (
                            <div key={index} className="item1">
                                <div className="search-lists">
                                    <div className="row m-0">
                                        <div className="col-3 d-flex align-items-center">
                                            <img src={Profile} alt="" />
                                        </div>
                                        <div className="col-9">
                                            <div className="p-3">
                                                <div className="d-flex w-100 res-view">
                                                    <span className='appoinment-name'>{hospital.name}</span>
                                                    <div className="mx-lg-2 mx-md-2 mx-0">
                                                        <h4>Wait Time: {hospital.waitTime} Minutes</h4>
                                                    </div>
                                                </div>
                                                <p>{hospital.address}</p>
                                            </div>
                                        </div>
                                        <div className="col-6 p-0">
                                            <button className="w-100 h-100 view-full"><a href='/login'>View Full Profile</a></button>
                                        </div>
                                        <div className="col-6 p-0">
                                            <button className="w-100 book-now">Book An Appointment</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </OwlCarousel>
                </div>
            </div>
        );
    }
}

export default SimpleSlider;